import ImmutablePropTypes from 'react-immutable-proptypes';
export const FolderMapPropOptional = ImmutablePropTypes.map;
export const FolderMapsByIdProp = ImmutablePropTypes.orderedMap.isRequired;
export const FolderMapsByIdPropOptional = ImmutablePropTypes.orderedMap;
const FolderMapProp = ImmutablePropTypes.map.isRequired;
export default FolderMapProp;